import React, { useState } from "react";
import { useFormikContext } from "formik";
import * as Yup from "yup";
import Error from "../../../components/Error/error";
import { MobileInputField } from "@fincity-frontend/shared-ui";
import { validate as validatePhoneNumber } from "../../../common/constants/PhoneNumberValidation";
import { useFormikWizard } from "formik-wizard";

const RegisterForm = (props) => {
	const [mobile_register, setRegister] = useState(false);
	const [mobile, setMobile] = useState("");
	const [email, setEmail] = useState("");
	const [checked, setChecked] = useState(false);
	const inputLength = mobile.length;
	const firstDigitModified = mobile.length > 0 && !/[6-9]|\./.test(mobile[0]);

	const handleCheckedChange = (e) => {
		setChecked(e.target.checked);
	};

	const {
		errors,
		touched,
		values,
		handleBlur,
		handleChange,
	} = useFormikContext();
	const { values: wizardValues, setStatus, status, user } = useFormikWizard();
	return (
		<div className=" flex-1  w-full h-72 md:h-64 max-w-xs  text-center mx-auto text-left mt-32 px-5 md:px-0">
			<p className="font-khand mx-auto font-semibold text-lg tracking-wider ">
				Reset password
			</p>
			{props.user == "consumer" ? (
				<React.Fragment>
					<div className="text-left">
						<MobileInputField
							name="phone"
							handleChange={handleChange}
							handleBlur={handleBlur}
							setMobile={setMobile}
							validatePhoneNumber={(e) => {
								validatePhoneNumber(e, inputLength), setRegister(false);
							}}
						/>
					</div>

					{/* checking the first Digit the input may be modified later */}
					{firstDigitModified ? (
						<div>
							<p className=" text-red-100 text-sm font-roboto">
								First digit cant be {values.phone[0]}
							</p>
						</div>
					) : null}
					{/* checking the first Digit the input */}
					<div className="text-left">
						<Error touched={touched.phone} message={errors.phone} />
					</div>
				</React.Fragment>
			) : (
				<React.Fragment>
					<label className="block mt-6 relative text-left">
						<span className=" block text-xs capitalize">Email ID</span>
						<div className="">
							<div className="outer-div flex w-full ">
								<input
									className=" showHide flex-1 placeholder-grey-placeholder form-input  rounded-sm mt-1  block w-full"
									type="text"
									id="email"
									name="email"
									placeholder="Enter your fincity email ID"
									value={values.email}
									onChange={(e) => {
										handleChange(e);
										setEmail(e.target.value);
									}}
									onBlur={(e) => {
										handleBlur(e);
									}}
									required
									minLength="8"
									maxLength="100"
								/>
							</div>
						</div>
					</label>
					<div className="text-left">
						<Error touched={touched.email} message={errors.email} />
					</div>
				</React.Fragment>
			)}
			<button
				id="submit"
				className="submitButton w-full capitalize"
				type="submit"
				disabled={
					props.user == "consumer"
						? mobile.length < 10 || firstDigitModified
						: email == "" || errors.email
				}
			>
				GET OTP
			</button>
			<div className=" mt-2 block text-red-200">{status?.message}</div>
		</div>
	);
};

export default RegisterForm;
